module.exports = __webpack_public_path__ + "static/media/bg3.e5ccd7b0.png";